/* ka-infinite-scroll.js (R32 T26 spec D47 row 7; rebuilt R39 T50 spec D55 row 10)
   Appends the next page's cards into a product grid before the visitor reaches the end.
   - Each page is fetched with &section_id=<the grid section's id>, so only the section HTML
     comes back, not the whole page (header, footer, scripts).
   - It starts when the pagination is 2 viewport heights away. When a page lands, the page after
     it is fetched right away and held, so the next append is instant.
   - The numbered pagination stays in the server HTML (visually hidden) so crawlers and no-JS
     visitors keep real ?page=N links; if a fetch fails the numbered links are shown again.
   - No card is appended twice: every card is keyed by its data-product-id.
   - No loading text: cards appear as they are ready.

   Markup contract (see sections/ka-collection-page.liquid):
     [data-ka-grid]        the grid whose children are cards; data-ka-section-id = the section id
     [data-ka-pagination]  <nav> holding the real page links, with a [data-ka-next] link
     [data-ka-more]        status line (end of list only)
   Optional: data-ka-total on any element = total product count for the end message. */
(function () {
  'use strict';
  var grid = document.querySelector('[data-ka-grid]');
  var nav = document.querySelector('[data-ka-pagination]');
  var status = document.querySelector('[data-ka-more]');
  var nextEl = document.querySelector('[data-ka-next]');
  if (!grid || !nav || !nextEl || !('IntersectionObserver' in window)) return;

  var sectionId = grid.getAttribute('data-ka-section-id');
  var nextUrl = nextEl.href;
  var held = null; /* { url, promise }: the page after the one on screen, already on its way */
  var appending = false;
  var seen = new Set();
  grid.querySelectorAll('[data-product-id]').forEach(function (c) { seen.add(c.getAttribute('data-product-id')); });
  nav.classList.add('ka-coll-pagination--js');

  function say(msg) {
    if (!status) return;
    status.hidden = !msg;
    status.textContent = msg || '';
  }

  /* One page: the section HTML for ?page=N, parsed into { cards, next }. */
  function fetchPage(url) {
    var u = new URL(url, window.location.href);
    if (sectionId) u.searchParams.set('section_id', sectionId);
    return fetch(u.href, { headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = Array.prototype.slice.call(doc.querySelectorAll('[data-ka-grid] > *'));
        if (!cards.length) throw new Error('no cards');
        var n = doc.querySelector('[data-ka-next]');
        return { cards: cards, next: n ? new URL(n.getAttribute('href'), window.location.href).href : null };
      });
  }

  /* Fetch the page after the one just appended and keep it. A failure here is not shown:
     the normal path retries when the visitor gets there. */
  function hold(url) {
    var entry = { url: url, promise: fetchPage(url) };
    entry.promise.catch(function () { if (held === entry) held = null; });
    held = entry;
  }

  function appendNext() {
    if (appending || !nextUrl) return;
    appending = true;
    var url = nextUrl;
    var page = held && held.url === url ? held.promise : fetchPage(url);
    held = null;
    page
      .then(function (data) {
        data.cards.forEach(function (c) {
          var idEl = c.matches('[data-product-id]') ? c : c.querySelector('[data-product-id]');
          var id = idEl ? idEl.getAttribute('data-product-id') : null;
          if (id && seen.has(id)) return;
          if (id) seen.add(id);
          grid.appendChild(document.adoptNode(c));
        });
        nextUrl = data.next;
        if (!nextUrl) {
          io.disconnect();
          nav.remove();
          var total = document.querySelector('[data-ka-total]');
          say(total && total.dataset.n ? 'That is all ' + total.dataset.n + ' products.' : 'That is everything.');
        } else {
          hold(nextUrl);
          /* Re-arm: if the sentinel is still near the viewport after this append (short pages,
             tall screens), IO would not fire again. */
          io.unobserve(nav);
          io.observe(nav);
        }
        appending = false;
      })
      .catch(function () {
        io.disconnect();
        nav.classList.remove('ka-coll-pagination--js');
        say('');
        held = null;
        appending = false;
      });
  }

  /* Bottom margin of 200% = 2 viewport heights below the screen. */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) appendNext();
    });
  }, { rootMargin: '0px 0px 200% 0px' });
  io.observe(nav);
})();
